module.exports = __webpack_public_path__ + "static/media/1-.3771ccc1.webp";